import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { SpeakingClassServiceAgGridQuery } from "../../AgGrid/sendSpeakingClassServiceAgGridQuery.ts";
import { ActivityPeriod } from "./activityPeriod.ts";
import { TeacherClassRoomRecord } from "./teacherClassRoomRecord.ts";

const CLASS_ROOMS_AG_GRID_QUERY_ID = "classrooms";
const MAX_CLASS_ROOMS_IN_PERIOD = 5000;
const AG_GRID_DATE_FORMAT = "YYYY-MM-DD";

function teacherClassRoomsInPeriodFilter(
  teacherId: string,
  period: ActivityPeriod,
) {
  return {
    franchiseeId: { filterType: "text", type: "equals", filter: teacherId },
    startUtc: {
      filterType: "date",
      type: "between",
      dateFrom: period.from.subtract(1, "day").format(AG_GRID_DATE_FORMAT),
      dateTo: period.to.add(2, "day").format(AG_GRID_DATE_FORMAT),
    },
  };
}

function parseAgGridRows(data: unknown): TeacherClassRoomRecord[] {
  if (typeof data === "string") return JSON.parse(data);
  return Array.isArray(data) ? data : [];
}

export function useTeacherClassRoomRecords({
  teacherId,
  period,
}: {
  teacherId: string;
  period: ActivityPeriod;
}) {
  const { data, loading, error } = useQuery(SpeakingClassServiceAgGridQuery, {
    fetchPolicy: "cache-and-network",
    variables: {
      params: {
        queryId: CLASS_ROOMS_AG_GRID_QUERY_ID,
        startRow: 0,
        endRow: MAX_CLASS_ROOMS_IN_PERIOD,
        filterModel: teacherClassRoomsInPeriodFilter(teacherId, period),
        sortModel: [],
        rowGroupCols: [],
        groupKeys: [],
        valueCols: [],
      },
    },
  });

  const classRooms = useMemo(
    () => parseAgGridRows(data?.speakingClassServiceAgGridQuery?.data),
    [data],
  );

  return { classRooms, loading: loading && !data, error };
}
